export default __webpack_public_path__ + "static/media/undo.db65a14d.svg";